var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.7602C0.0412128 7.63164 0.109599 7.51484 0.199951 7.41902L6.80005 0.309046C6.95172 0.148912 7.15652 0.059082 7.36999 0.059082C7.58347 0.059082 7.78827 0.148912 7.93994 0.309046C8.07853 0.460045 8.16261 0.658418 8.17725 0.869089C8.19188 1.07976 8.13623 1.28924 8.02002 1.46036L7.93994 1.55626L2.73999 7.15253H17.12C17.341 7.15812 17.5511 7.25643 17.7046 7.42605C17.8581 7.59567 17.9426 7.8229 17.9399 8.05857C17.9373 8.26898 17.8644 8.47156 17.7343 8.6298C17.6041 8.78804 17.4253 8.89165 17.23 8.92205H2.80005L8 14.529C8.1545 14.6947 8.24121 14.9189 8.24121 15.1525C8.24121 15.3862 8.1545 15.6103 8 15.7761C7.86211 15.927 7.67718 16.0191 7.4801 16.0348C7.28303 16.0505 7.08746 15.9888 6.93005 15.8614L6.83996 15.7761L0.23999 8.66623C0.137251 8.55443 0.063824 8.41579 0.0269775 8.26429C-0.00986891 8.11279 -0.00880863 7.95368 0.0300293 7.80275L0 7.7602Z",
    fill: "#262A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.668ceed94ff15b17d9a614e5498132b0.svg";
export { ForwardRef as ReactComponent };